import { render, staticRenderFns } from "./nxMobileFile.vue?vue&type=template&id=6e70417c&scoped=true&"
import script from "./nxMobileFile.vue?vue&type=script&lang=js&"
export * from "./nxMobileFile.vue?vue&type=script&lang=js&"
import style0 from "./nxMobileFile.vue?vue&type=style&index=0&id=6e70417c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e70417c",
  null
  
)

export default component.exports